import React, { useEffect } from 'react';
import LandingNavbar from '../components/Landing/LandingNavbar';
import LandingFooter from '../components/Landing/LandingFooter';
import './landing.css';

const ProcessPage: React.FC = () => {
    useEffect(() => {
        const observerOptions = {
            threshold: 0.1,
            rootMargin: '0px 0px -50px 0px'
        };

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('animate-in');
                }
            });
        }, observerOptions);

        document.querySelectorAll('.process-step').forEach(el => {
            observer.observe(el);
        });

        return () => observer.disconnect();
    }, []);

    return (
        <div className="main-landing-admin">
            <LandingNavbar />

            <section className="process-page hero-sub">
                <div className="container">
                    <div className="hero-sub-content">
                        <h1 className="section-title gradient-text">Our <span>Process</span></h1>
                        <p className="hero-description">
                            How we take you from raw data to actionable AI-powered intelligence.
                        </p>
                    </div>

                    <div className="process-steps">
                        <div className="process-step">
                            <div className="step-number">01</div>
                            <div className="step-content">
                                <h3>Discovery & Data Analysis</h3>
                                <p>We begin by understanding your business challenges and auditing your existing data landscape to ensure an AI-ready foundation.</p>
                                <ul>
                                    <li>Strategic objectives alignment</li>
                                    <li>Data quality & quantity assessment</li>
                                    <li>Feasibility study & ROI mapping</li>
                                </ul>
                            </div>
                        </div>

                        <div className="process-step">
                            <div className="step-number">02</div>
                            <div className="step-content">
                                <h3>Architecture & Model Design</h3>
                                <p>Our experts design the custom neural network architectures and data pipelines specifically tailored to your use case.</p>
                                <ul>
                                    <li>Model selection (LLM, CV, etc.)</li>
                                    <li>Infrastucture planning</li>
                                    <li>Security & compliance design</li>
                                </ul>
                            </div>
                        </div>

                        <div className="process-step">
                            <div className="step-number">03</div>
                            <div className="step-content">
                                <h3>Training & Iterative Testing</h3>
                                <p>We train the models on your data and perform rigorous testing to ensure accuracy and bias elimination.</p>
                                <ul>
                                    <li>Hyperparameter optimization</li>
                                    <li>Validation on real-world scenarios</li>
                                    <li>Edge-case stress testing</li>
                                </ul>
                            </div>
                        </div>

                        <div className="process-step">
                            <div className="step-number">04</div>
                            <div className="step-content">
                                <h3>Scalable Deployment</h3>
                                <p>We deploy the solution into your production environment using MLOps best practices for high availability.</p>
                                <ul>
                                    <li>Continuous Integration/Deployment</li>
                                    <li>API documentation for your team</li>
                                    <li>Legacy system sync</li>
                                </ul>
                            </div>
                        </div>

                        <div className="process-step">
                            <div className="step-number">05</div>
                            <div className="step-content">
                                <h3>Monitoring & Continuous Learning</h3>
                                <p>AI is never static. We continuously monitor performance and retrain models to adapt to changing data trends.</p>
                                <ul>
                                    <li>Real-time performance dashboards</li>
                                    <li>Automatic drift detection</li>
                                    <li>Ongoing optimization & updates</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <LandingFooter />
        </div>
    );
};

export default ProcessPage;
